<template lang="pug">
.initial-key
  .initial-key-container
    .initial-key-logo
      img(src="@/assets/img/emblem-white.svg")
    template(v-if="initKey !== 0")
      template(v-if="!_.includes(configError, 'NO_APP')")
        p
          strong Use this code to pair your device with BergOS
        ul.initial-key-code
          li(
            v-for="(digit, index) in keyDigits"
            :key="index"
          ) {{ digit }}
      .initial-key-error(v-else)
        span(v-if="_.includes(configError, 'NO_APP')") Please assign the device to Digital Signage app...
    loader.initial-key-loader(v-else, large)
</template>

<script>
import Loader from '@/components/Loader'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'InitialKey',
  components: {
    Loader
  },
  computed: {
    ...mapGetters({
      configError: 'device/configError',
      initKey: 'device/initKey'
    }),
    keyDigits() {
      return this.initKey.toString().split('')
    }
  },
  created() {
    this.setIdentity()
  },
  methods: {
    ...mapActions({
      setIdentity: 'device/setIdentity'
    })
  }
}
</script>

<style lang="scss">
.initial-key {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .initial-key-logo {
    margin-bottom: 4rem;
    img {
      height: 5rem;
    }
  }

  .initial-key-intro {
    font-size: 1.75rem;
    opacity: 0.3;
    margin-bottom: 0;
  }

  .initial-key-title {
    font-size: 5rem;
    margin-bottom: 2.5rem;
  }

  p {
    font-size: 1.3rem;
  }

  .initial-key-code {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 1rem;
      border-radius: 0.25rem;
      color: $color-global;
      display: inline-block;
      font-size: 1.75rem;
      font-weight: $font-primary-bold;
      margin: 0 0.25rem;
      border: 1px solid $color-line-light;
    }
  }

  .initial-key-error {
    text-align: center;
    font-size: 1.25rem;
    opacity: 0.5;
  }
}
</style>
